/**
 * @file 师资
 * @author 丁聪
 */

import React, { Component } from 'react'
import {
  Banner,
  Items,
  Dream,
  Teacher,
  TeacherList,
  ParentList,
} from './components/'
import { Footer } from '../../components/basic/index'

import './index.scss'


class Teachers extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let recruitList = [{ text: '筛选简历' }, { text: '初次面试' }, { text: '入职试讲' }, { text: '系统培训' }, { text: '培训考核' }, { text: '岗前试讲' }, { text: '正式上岗' },]
    return (
      <div className='teachers'>
        <Banner />
        <Items />
        {/* <Dream /> */}
        <div className='recruit'>
          <div className="inner-title" style={{ marginBottom: '14px' }}>严格的教师录用机制</div>
          <div className="inner-extra">7层筛选+系统培训&nbsp;&nbsp;一定有你想要的中文教师</div>
          <ul className='img-bg'>
            {recruitList.map((item, index) => (
              <li className='img' key={index}>{item.text}</li>
            ))}
          </ul>
        </div>
        {/* <Teacher /> */}
        <div className="introduce">
          <div className="inner">
            <div className="study-title">哈兔优质中文教师，助力成长每一步</div>
            <div className="heng"></div>
            <div className="study-title-sub">爱孩子、懂教育、热情、专业、负责</div>
          </div>
          <TeacherList />
        </div>
        <div className="how">
          <div className="inner">
            <div className="inner-title">教师风采</div>
          </div>
          <ParentList />
        </div>
        <Footer />
      </div>
    )
  }
}

export default Teachers
